import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2AdminNotesWorkflowsEditNote: build.mutation<
      PostV2AdminNotesWorkflowsEditNoteApiResponse,
      PostV2AdminNotesWorkflowsEditNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes-workflows/edit-note`,
        method: "POST",
        body: queryArg.editNoteRequest,
      }),
    }),
    getV2AdminNotesWorkflowsStatusByTaskId: build.query<
      GetV2AdminNotesWorkflowsStatusByTaskIdApiResponse,
      GetV2AdminNotesWorkflowsStatusByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes-workflows/status/${queryArg.taskId}`,
      }),
    }),
    getV2AdminNotesByNoteId: build.query<
      GetV2AdminNotesByNoteIdApiResponse,
      GetV2AdminNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/notes/${queryArg.noteId}` }),
    }),
    postV2AdminNotesByNoteIdGeneratePdf: build.mutation<
      PostV2AdminNotesByNoteIdGeneratePdfApiResponse,
      PostV2AdminNotesByNoteIdGeneratePdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes/${queryArg.noteId}/generate-pdf`,
        method: "POST",
      }),
    }),
    getV2AdminProvidersByProviderIdNotes: build.query<
      GetV2AdminProvidersByProviderIdNotesApiResponse,
      GetV2AdminProvidersByProviderIdNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/notes`,
      }),
    }),
    postV2ProviderNoteGenerationCustomize: build.mutation<
      PostV2ProviderNoteGenerationCustomizeApiResponse,
      PostV2ProviderNoteGenerationCustomizeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/customize`,
        method: "POST",
        body: queryArg.customizeModuleRequest,
      }),
    }),
    postV2ProviderNoteGenerationCustomizeApplyByThreadId: build.mutation<
      PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiResponse,
      PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/customize/apply/${queryArg.threadId}`,
        method: "POST",
        body: queryArg.applyCustomizationRequest,
      }),
    }),
    getV2ProviderNoteGenerationCustomizeHistoryByThreadId: build.query<
      GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiResponse,
      GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/customize/history/${queryArg.threadId}`,
      }),
    }),
    postV2ProviderNoteGenerationGenerate: build.mutation<
      PostV2ProviderNoteGenerationGenerateApiResponse,
      PostV2ProviderNoteGenerationGenerateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/generate`,
        method: "POST",
        body: queryArg.generateModuleTextRequest,
      }),
    }),
    getV2ProviderNoteGenerationStreamByThreadId: build.query<
      GetV2ProviderNoteGenerationStreamByThreadIdApiResponse,
      GetV2ProviderNoteGenerationStreamByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/stream/${queryArg.threadId}`,
      }),
    }),
    getV2ProviderNoteProcessingWorkflowsStatusByThreadId: build.query<
      GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiResponse,
      GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-processing-workflows/status/${queryArg.threadId}`,
      }),
    }),
    getV2ProviderNoteProcessingWorkflowsStreamByThreadId: build.query<
      GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiResponse,
      GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-processing-workflows/stream/${queryArg.threadId}`,
      }),
    }),
    postV2ProviderNotesWorkflowsEditNote: build.mutation<
      PostV2ProviderNotesWorkflowsEditNoteApiResponse,
      PostV2ProviderNotesWorkflowsEditNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes-workflows/edit-note`,
        method: "POST",
        body: queryArg.providerEditNoteRequest,
      }),
    }),
    getV2ProviderNotesWorkflowsStatusByTaskId: build.query<
      GetV2ProviderNotesWorkflowsStatusByTaskIdApiResponse,
      GetV2ProviderNotesWorkflowsStatusByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes-workflows/status/${queryArg.taskId}`,
      }),
    }),
    getV2ProviderNotesByNoteId: build.query<
      GetV2ProviderNotesByNoteIdApiResponse,
      GetV2ProviderNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/provider/notes/${queryArg.noteId}` }),
    }),
    patchV2ProviderNotesByNoteId: build.mutation<
      PatchV2ProviderNotesByNoteIdApiResponse,
      PatchV2ProviderNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}`,
        method: "PATCH",
        body: queryArg.updateNoteRequest,
      }),
    }),
    getV2ProviderNotesByNoteIdActionsSuggested: build.query<
      GetV2ProviderNotesByNoteIdActionsSuggestedApiResponse,
      GetV2ProviderNotesByNoteIdActionsSuggestedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/actions/suggested`,
      }),
    }),
    postV2ProviderNotesByNoteIdRedo: build.mutation<
      PostV2ProviderNotesByNoteIdRedoApiResponse,
      PostV2ProviderNotesByNoteIdRedoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/redo`,
        method: "POST",
      }),
    }),
    postV2ProviderNotesByNoteIdSections: build.mutation<
      PostV2ProviderNotesByNoteIdSectionsApiResponse,
      PostV2ProviderNotesByNoteIdSectionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections`,
        method: "POST",
        body: queryArg.addSectionsRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdSectionsReorder: build.mutation<
      PostV2ProviderNotesByNoteIdSectionsReorderApiResponse,
      PostV2ProviderNotesByNoteIdSectionsReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/reorder`,
        method: "POST",
        body: queryArg.reorderSectionsRequest,
      }),
    }),
    deleteV2ProviderNotesByNoteIdSectionsAndSectionId: build.mutation<
      DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiResponse,
      DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/${queryArg.sectionId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderNotesByNoteIdSectionsAndSectionIndex: build.mutation<
      PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiResponse,
      PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/${queryArg.sectionIndex}`,
        method: "PATCH",
        body: queryArg.editSectionRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdSectionsAndSectionIndexRevert: build.mutation<
      PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiResponse,
      PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/${queryArg.sectionIndex}/revert`,
        method: "POST",
      }),
    }),
    getV2ProviderNotesByNoteIdSignedPdf: build.query<
      GetV2ProviderNotesByNoteIdSignedPdfApiResponse,
      GetV2ProviderNotesByNoteIdSignedPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/signed-pdf`,
      }),
    }),
    patchV2ProviderNotesByNoteIdTemplate: build.mutation<
      PatchV2ProviderNotesByNoteIdTemplateApiResponse,
      PatchV2ProviderNotesByNoteIdTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/template`,
        method: "PATCH",
        body: queryArg.updateNoteTemplateRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdUndo: build.mutation<
      PostV2ProviderNotesByNoteIdUndoApiResponse,
      PostV2ProviderNotesByNoteIdUndoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/undo`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2AdminNotesWorkflowsEditNoteApiResponse =
  /** status 200 OK */ WorkflowResponse;
export type PostV2AdminNotesWorkflowsEditNoteApiArg = {
  editNoteRequest: EditNoteRequest;
};
export type GetV2AdminNotesWorkflowsStatusByTaskIdApiResponse =
  /** status 200 OK */ WorkflowStatusResponse;
export type GetV2AdminNotesWorkflowsStatusByTaskIdApiArg = {
  taskId: string;
};
export type GetV2AdminNotesByNoteIdApiResponse =
  /** status 200 OK */ AdminNoteDetailResponse;
export type GetV2AdminNotesByNoteIdApiArg = {
  noteId: string;
};
export type PostV2AdminNotesByNoteIdGeneratePdfApiResponse =
  /** status 200 OK */ GenerateNotePdfResponse;
export type PostV2AdminNotesByNoteIdGeneratePdfApiArg = {
  noteId: string;
};
export type GetV2AdminProvidersByProviderIdNotesApiResponse =
  /** status 200 OK */ ListResponseAdminNoteListItem;
export type GetV2AdminProvidersByProviderIdNotesApiArg = {
  providerId: string;
};
export type PostV2ProviderNoteGenerationCustomizeApiResponse =
  /** status 200 OK */ CustomizeModuleResponse;
export type PostV2ProviderNoteGenerationCustomizeApiArg = {
  customizeModuleRequest: CustomizeModuleRequest;
};
export type PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiResponse =
  /** status 200 OK */ ApplyCustomizationResponse;
export type PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiArg = {
  threadId: string;
  applyCustomizationRequest: ApplyCustomizationRequest;
};
export type GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiResponse =
  /** status 200 OK */ CustomizeModuleHistoryResponse;
export type GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiArg = {
  threadId: string;
};
export type PostV2ProviderNoteGenerationGenerateApiResponse =
  /** status 200 OK */ GenerateModuleTextResponse;
export type PostV2ProviderNoteGenerationGenerateApiArg = {
  generateModuleTextRequest: GenerateModuleTextRequest;
};
export type GetV2ProviderNoteGenerationStreamByThreadIdApiResponse = unknown;
export type GetV2ProviderNoteGenerationStreamByThreadIdApiArg = {
  threadId: string;
};
export type GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiResponse =
  /** status 200 OK */ ProcessingStatusResponse;
export type GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiArg = {
  threadId: string;
};
export type GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiResponse =
  unknown;
export type GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiArg = {
  threadId: string;
};
export type PostV2ProviderNotesWorkflowsEditNoteApiResponse =
  /** status 200 OK */ WorkflowResponse;
export type PostV2ProviderNotesWorkflowsEditNoteApiArg = {
  providerEditNoteRequest: ProviderEditNoteRequest;
};
export type GetV2ProviderNotesWorkflowsStatusByTaskIdApiResponse =
  /** status 200 OK */ WorkflowStatusResponse;
export type GetV2ProviderNotesWorkflowsStatusByTaskIdApiArg = {
  taskId: string;
};
export type GetV2ProviderNotesByNoteIdApiResponse =
  /** status 200 OK */ NoteResponse;
export type GetV2ProviderNotesByNoteIdApiArg = {
  noteId: string;
};
export type PatchV2ProviderNotesByNoteIdApiResponse =
  /** status 200 OK */ NoteResponse;
export type PatchV2ProviderNotesByNoteIdApiArg = {
  noteId: string;
  updateNoteRequest: UpdateNoteRequest;
};
export type GetV2ProviderNotesByNoteIdActionsSuggestedApiResponse =
  /** status 200 OK */ ActionListResponse;
export type GetV2ProviderNotesByNoteIdActionsSuggestedApiArg = {
  noteId: string;
};
export type PostV2ProviderNotesByNoteIdRedoApiResponse =
  /** status 200 OK */ NoteResponse;
export type PostV2ProviderNotesByNoteIdRedoApiArg = {
  noteId: string;
};
export type PostV2ProviderNotesByNoteIdSectionsApiResponse =
  /** status 201 Created */ NoteResponse;
export type PostV2ProviderNotesByNoteIdSectionsApiArg = {
  noteId: string;
  addSectionsRequest: AddSectionsRequest;
};
export type PostV2ProviderNotesByNoteIdSectionsReorderApiResponse =
  /** status 200 OK */ NoteResponse;
export type PostV2ProviderNotesByNoteIdSectionsReorderApiArg = {
  noteId: string;
  reorderSectionsRequest: ReorderSectionsRequest;
};
export type DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiResponse =
  /** status 200 OK */ NoteResponse;
export type DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiArg = {
  noteId: string;
  sectionId: string;
};
export type PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiResponse =
  /** status 200 OK */ EditSectionResponse;
export type PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiArg = {
  noteId: string;
  sectionIndex: number;
  editSectionRequest: EditSectionRequest;
};
export type PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiResponse =
  unknown;
export type PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiArg = {
  noteId: string;
  sectionIndex: number;
};
export type GetV2ProviderNotesByNoteIdSignedPdfApiResponse = unknown;
export type GetV2ProviderNotesByNoteIdSignedPdfApiArg = {
  noteId: string;
};
export type PatchV2ProviderNotesByNoteIdTemplateApiResponse =
  /** status 200 OK */ NoteResponse;
export type PatchV2ProviderNotesByNoteIdTemplateApiArg = {
  noteId: string;
  updateNoteTemplateRequest: UpdateNoteTemplateRequest;
};
export type PostV2ProviderNotesByNoteIdUndoApiResponse =
  /** status 200 OK */ NoteResponse;
export type PostV2ProviderNotesByNoteIdUndoApiArg = {
  noteId: string;
};
export type WorkflowResponse = {
  /** Current status */
  status: string;
  /** Task ID for tracking */
  task_id: string;
  /** Thread ID for state management */
  thread_id: string;
  /** Name of the workflow */
  workflow_name: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type EditNoteRequest = {
  /** Note ID to edit */
  note_id: string;
  /** Organization ID */
  organization_id?: string | null;
  /** Provider ID for context gathering */
  provider_id: string;
  /** Text input for editing */
  text: string;
};
export type WorkflowStatusResponse = {
  /** Error message if failed */
  error?: string | null;
  /** Whether the task is complete */
  ready: boolean;
  /** Task result if successful */
  result?: any | null;
  /** Task status (PENDING, SUCCESS, FAILURE, etc) */
  status: string;
  /** Whether the task succeeded */
  successful?: boolean | null;
  /** Task ID */
  task_id: string;
};
export type AdminAppointmentSummary = {
  appointment_id: string;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  title?: string | null;
};
export type AdminEncounterSummary = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  input_documents?: number | null;
  patient_id?: string | null;
  status?: string | null;
  updated_at?: string | null;
};
export type AdminNoteDetail = {
  created_at?: string | null;
  encounter_id?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  patient_id?: string | null;
  patient_name?: string | null;
  provider_id?: string | null;
  status?: string | null;
  template?: string | null;
  updated_at?: string | null;
};
export type AdminNoteProcessingSessionSummary = {
  created_at?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  status?: string | null;
  transcription_session_ids?: string[] | null;
};
export type AdminProviderSummary = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminNoteDetailResponse = {
  appointment?: AdminAppointmentSummary | null;
  encounter?: AdminEncounterSummary | null;
  note: AdminNoteDetail;
  note_processing_sessions: AdminNoteProcessingSessionSummary[];
  provider: AdminProviderSummary;
  transcriptions: AdminTranscriptionSummary[];
};
export type GenerateNotePdfResponse = {
  /** Path where the PDF was saved */
  file_path: string;
  /** Size of the generated PDF file in bytes */
  file_size_bytes: number;
  /** The note ID */
  note_id: string;
  /** Whether PDF generation succeeded */
  success: boolean;
};
export type AdminNoteListItem = {
  created_at: string;
  encounter_id?: string | null;
  encounter_type?: string | null;
  has_feedback: boolean;
  note_id: string;
  patient_name?: string | null;
  status: string;
  template: string;
  transcript_id?: string | null;
};
export type ListResponseAdminNoteListItem = {
  items: AdminNoteListItem[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type CustomizeModuleResponse = {
  /** Processing status */
  status: string;
  /** URL to connect for SSE streaming */
  stream_url: string;
  /** Celery task ID for tracking */
  task_id: string;
  /** Thread ID for this operation */
  thread_id: string;
};
export type CustomizeModuleRequest = {
  /** ID of the encounter */
  encounter_id?: string | null;
  /** Feedback to improve the generation prompt */
  feedback: string;
  /** Optional partial module updates (e.g., {'generation_prompt': 'xxx'}) */
  module?: {
    [key: string]: any;
  } | null;
  /** ID of the module to customize */
  module_id?: string | null;
  /** ID of the note containing context */
  note_id?: string | null;
  /** ID of the template (schema_version 2) */
  template_id?: string | null;
  /** Optional template_prompt_md override (for mode 2, when frontend provides updated prompt) */
  template_prompt_md?: string | null;
  /** Optional thread ID for conversation context */
  thread_id?: string | null;
};
export type ApplyCustomizationResponse = {
  /** Version number that was applied */
  applied_version: number;
  /** Module ID (may be new if forked from public module) */
  module_id: string;
  /** New module version number in database */
  module_version: number;
  /** Original module ID if it was forked (only present if forked) */
  previous_module_id?: string | null;
};
export type ApplyCustomizationRequest = {
  /** Version number to apply (defaults to latest/current version) */
  version?: number | null;
};
export type CustomizeModuleHistoryResponse = {
  /** Current version number */
  current_version: number;
  /** Module ID being customized */
  module_id: string;
  /** Thread ID for this conversation */
  thread_id: string;
  /** Complete history of all versions with prompts, explanations, and examples */
  version_history: {
    [key: string]: any;
  }[];
};
export type GenerateModuleTextResponse = {
  /** Processing status */
  status: string;
  /** URL to connect for SSE streaming */
  stream_url: string;
  /** Celery task ID for tracking */
  task_id: string;
  /** Thread ID for this operation */
  thread_id: string;
};
export type GenerateModuleTextRequest = {
  /** ID of the encounter */
  encounter_id?: string | null;
  /** Optional partial module updates (e.g., {'generation_prompt': 'xxx'}) */
  module?: {
    [key: string]: any;
  } | null;
  /** ID of the module to generate text for */
  module_id?: string | null;
  /** ID of the note containing context */
  note_id?: string | null;
  /** ID of the template (schema_version 2) */
  template_id?: string | null;
  /** Optional thread ID for conversation context */
  thread_id?: string | null;
};
export type WorkflowStepInfo = {
  /** Human-readable step name */
  display_name: string;
  /** Step identifier */
  id: string;
  /** Step order (0-indexed) */
  order: number;
};
export type ProcessingStatusResponse = {
  /** List of completed step IDs */
  completed_steps?: string[];
  /** ID of the currently executing step */
  current_step?: string | null;
  /** Human-readable name of current step */
  current_step_display_name?: string | null;
  /** Associated encounter ID */
  encounter_id?: string | null;
  /** Associated note ID */
  note_id?: string | null;
  /** Current status: pending, processing, completed, error */
  status: string;
  /** Full list of workflow steps (visible only) with metadata */
  steps?: WorkflowStepInfo[];
  /** Thread ID for the workflow */
  thread_id: string;
  /** Total number of visible steps */
  total_steps?: number;
  /** Name of the workflow being executed */
  workflow_name?: string | null;
};
export type ProviderEditNoteRequest = {
  /** Note ID to edit */
  note_id: string;
  /** Organization ID */
  organization_id?: string | null;
  /** Text input for editing */
  text: string;
};
export type NoteSection = {
  /** Section context/metadata */
  context?: any | null;
  /** Edited section text */
  edited_text?: string | null;
  /** Edit history */
  edits?: any[] | null;
  /** Error message if generation failed */
  error?: string | null;
  /** Whether section has been rated */
  is_rated?: boolean | null;
  /** Whether section text is markdown-formatted */
  markdown?: boolean | null;
  /** Model used for generation */
  model?: string | null;
  /** Module ID */
  module_id?: string | null;
  /** Section name */
  name: string;
  /** Section priority */
  priority?: number | null;
  /** Section generation version */
  section_generation_version?: number | null;
  /** Section ID */
  section_id: string;
  /** Original section text */
  text: string;
};
export type NoteContent = {
  /** Extra content */
  extras?: any | null;
  /** Note sections */
  sections?: NoteSection[];
};
export type EncounterDocumentReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Encounter document ID */
  encounter_document_id: string;
  /** Output status */
  status?: "pending" | "completed";
  /** Document title for display */
  title?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** JotDoc ID (None for pending outputs) */
  jotdoc_id?: string | null;
  /** Output status */
  status?: "pending" | "completed";
  /** Task ID for tracking (optional, for debugging) */
  task_id?: string | null;
  /** Thread ID for building SSE stream URL */
  thread_id?: string | null;
  /** Document title */
  title?: string | null;
  /** Document type */
  type?: string;
};
export type EncounterInfo = {
  /** Encounter ID */
  encounter_id: string;
  /** Output documents or notes */
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  /** Whether transcripts have been deleted for this encounter */
  transcripts_deleted?: boolean;
};
export type UserInfo = {
  /** User name */
  name: string;
  /** User ID */
  user_id: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type TemplatePermissions = {
  can_delete?: boolean;
  can_edit?: boolean;
  can_fork?: boolean;
  can_view?: boolean;
};
export type NoteTemplateInfo = {
  /** Template owner scope: 'public', 'org', or 'user' */
  owner_scope?: string | null;
  /** Template ID */
  template_id?: string | null;
  /** Template name */
  template_name?: string | null;
  /** Computed permissions for the template (can_edit, can_fork, etc.) */
  template_permissions?: TemplatePermissions | null;
  /** Template version used to generate this note */
  template_version?: number | null;
};
export type NoteResponse = {
  /** Whether the note can have context added (based on size) */
  can_add_context: boolean;
  /** Whether the note can be edited */
  can_edit_template: boolean;
  /** Whether the note can be redone to a next version */
  can_redo: boolean;
  /** Whether the note can be regenerated (false if transcripts deleted) */
  can_regenerate: boolean;
  /** Whether the note can be undone to a previous version */
  can_undo: boolean;
  /** Note completion status */
  completion_status?: string | null;
  /** When the note was completed (Unix timestamp) */
  completion_timestamp?: number | null;
  /** Note content with sections */
  content: NoteContent;
  /** Current version ID for undo/redo tracking */
  current_version?: string | null;
  /** Associated encounter information */
  encounter?: EncounterInfo | null;
  /** Error message, if any */
  error_message?: string | null;
  /** Whether note has feedback */
  has_feedback?: boolean | null;
  /** Internal note title */
  internal_title?: string | null;
  /** Whether note has been copied */
  is_copied?: boolean | null;
  /** Whether note has been rated */
  is_rated?: boolean | null;
  /** Whether note is signed */
  is_signed?: boolean | null;
  /** User who created the note */
  issuing_user: UserInfo;
  /** Note ID */
  note_id: string;
  /** Note title */
  note_title?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Associated patient information */
  patient?: PatientInfo | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Section generation status (processing/completed) */
  sections_status?: string | null;
  /** Note status */
  status: string;
  /** Template info */
  template?: NoteTemplateInfo | null;
  /** Combined text from encounter documents and provided context */
  text_notes_string?: string | null;
  /** Thread ID for SSE streaming */
  thread_id?: string | null;
  /** Creation timestamp */
  time_uploaded?: number | null;
  /** Transcript data */
  transcript?: any[] | null;
  /** Transcription end time */
  transcription_end_timestamp?: number | null;
  /** Transcription length in seconds */
  transcription_length_seconds?: number | null;
  /** Transcription start time */
  transcription_start_timestamp?: number | null;
};
export type NoteCompletionStatus = "reviewing" | "completed";
export type UpdateNoteRequest = {
  /** New completion status (reviewing or completed) */
  completion_status?: NoteCompletionStatus | null;
  /** Mark note as copied */
  is_copied?: boolean | null;
  /** New note title */
  note_title?: string | null;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type ActionResponse = {
  action_id: string;
  action_payload: {
    [key: string]: any;
  };
  action_type: string;
  created_at: string;
  encounter_id: string | null;
  patient?: PatientInfo2 | null;
  provider_id: string;
  state: string;
  updated_at: string;
};
export type ActionListResponse = {
  items: ActionResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type AddSectionsRequest = {
  /** Position to insert sections (0-based index) */
  insert_index: number;
  /** List of module IDs to generate sections from */
  module_ids: string[];
};
export type ReorderSectionsRequest = {
  /** Ordered list of section IDs defining the new order */
  sections: string[];
};
export type EditSectionResponse = {
  diff: any[];
};
export type EditSectionRequest = {
  /** The new edited text for the section */
  edited_text: string;
};
export type NoteTemplateSectionRequest = {
  content: string;
  /** Preview of what this section generates */
  example_output?: string | null;
  id: string;
  order?: number;
  title: string;
};
export type UpdateNoteTemplateRequest = {
  allow_user_forks?: boolean | null;
  description?: string | null;
  prompt?: string | null;
  sections?: NoteTemplateSectionRequest[] | null;
  title?: string | null;
};
